import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { motion } from "framer-motion";
import { IMG } from "../lib/api";

const SERVICES = [
  {
    to: "/implantes-dentales-calafell",
    title: "Implantes dentales",
    desc: "Recupera tu sonrisa con implantes de titanio biocompatibles. Colocación indolora guiada por TAC 3D.",
    img: IMG.treatments.implantes,
    span: "md:col-span-2 md:row-span-2",
    tag: "Más solicitado",
  },
  {
    to: "/ortodoncia-invisible-calafell",
    title: "Ortodoncia invisible",
    desc: "Alinea tu sonrisa sin que se note con Invisalign.",
    img: IMG.treatments.ortodoncia,
    span: "md:col-span-1",
  },
  {
    to: "/estetica-dental",
    title: "Estética dental",
    desc: "Carillas, blanqueamiento y diseño de sonrisa.",
    img: IMG.treatments.estetica,
    span: "md:col-span-1",
  },
  {
    to: "/odontopediatria",
    title: "Odontopediatría",
    desc: "Dentistas especializados en niños, sin miedo, sin traumas.",
    img: IMG.treatments.odontopediatria,
    span: "md:col-span-1",
  },
  {
    to: "/urgencias-dentales-calafell",
    title: "Urgencias dentales",
    desc: "Atención el mismo día ante cualquier emergencia en Calafell.",
    img: IMG.treatments.urgencias,
    span: "md:col-span-1",
    tag: "Urgencias",
    urgent: true,
  },
];

export default function ServicesBento() {
  return (
    <section className="py-24 bg-white" data-testid="services-section">
      <div className="container-max">
        <div className="flex flex-col md:flex-row md:items-end justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <div className="inline-flex items-center gap-2 bg-teal-50 rounded-full px-4 py-1.5 mb-5">
              <span className="text-xs font-semibold text-teal-700 uppercase tracking-wider">Nuestros tratamientos</span>
            </div>
            <h2 className="text-4xl sm:text-5xl font-bold text-slate-900 leading-tight">
              Atención dental <span className="underline-accent">integral</span> para toda la familia
            </h2>
          </div>
          <p className="text-slate-600 max-w-sm text-sm leading-relaxed">
            Todos los tratamientos que necesitas bajo el mismo techo.
            Sin desplazamientos, con los mismos doctores siempre.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 auto-rows-[260px] gap-4">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.to}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className={s.span}
            >
              <Link
                to={s.to}
                data-testid={`service-card-${s.to.replace(/\//g, "-")}`}
                className="service-card group relative h-full block rounded-3xl overflow-hidden border border-slate-200 bg-white"
              >
                <div className="absolute inset-0">
                  <img
                    src={s.img}
                    alt={s.title}
                    className="service-img w-full h-full object-cover"
                    loading="lazy"
                  />
                  <div className={`absolute inset-0 ${s.urgent ? "bg-gradient-to-t from-amber-900/85 via-amber-900/40 to-transparent" : "bg-gradient-to-t from-slate-900/85 via-slate-900/30 to-transparent"}`} />
                </div>
                <div className="relative h-full flex flex-col justify-between p-6">
                  <div className="flex justify-between items-start">
                    {s.tag && (
                      <span className={`inline-flex items-center gap-1 text-xs font-semibold px-3 py-1 rounded-full ${
                        s.urgent ? "bg-amber-500 text-white" : "bg-white text-teal-700"
                      }`}>
                        {s.urgent && <span className="relative w-2 h-2 rounded-full bg-white pulse-dot" />}
                        {s.tag}
                      </span>
                    )}
                    <div className="w-9 h-9 rounded-full bg-white/90 flex items-center justify-center ml-auto group-hover:bg-orange-600 group-hover:text-white transition-colors text-slate-900">
                      <ArrowUpRight className="w-4 h-4" />
                    </div>
                  </div>
                  <div>
                    <h3 className="text-2xl font-bold text-white mb-2 leading-tight">{s.title}</h3>
                    <p className="text-sm text-white/90 leading-relaxed max-w-sm">{s.desc}</p>
                  </div>
                </div>
              </Link>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
